import { Chip, FormControl, Typography } from '@mui/material';
import * as i18next from 'i18next';
import { FunctionComponent } from 'react';
import { ValidatorComponent } from 'react-form-validator-core';

interface State {
  isValid: boolean;
  value: Number[];
}

interface ValidatorComponentProps {
  errorMessages?: string[] | string;
  validators?: string[];
  validatorListener?: () => void;
  withRequiredValidator?: boolean;
  t: i18next.TFunction;
  containerClass?: String;
}

interface DiscreteStatesProps {
  onClickDelete: (state: number) => void;
  value: number[];
}

const DiscreteStates: FunctionComponent<DiscreteStatesProps> = (props: DiscreteStatesProps) => {
  const { onClickDelete, value } = props;
  const getOnDelete = (stateValue: number) => () => onClickDelete(stateValue);
  return (
    <div style={{ marginBottom: '10px', marginLeft: '10px' }}>
      {value.map((stateValue) => (
        <Chip
          id={`${stateValue}`}
          key={`discrete-state-chip-${stateValue}`}
          label={`${stateValue}`}
          onDelete={getOnDelete(stateValue)}
        />
      ))}
    </div>
  );
};

export class DiscreteStatesValidator extends ValidatorComponent<ValidatorComponentProps & DiscreteStatesProps, State> {
  state: State = {
    isValid: true,
    value: [],
  };

  render() {
    /* eslint-disable no-unused-vars */
    return (
      <FormControl variant="filled" fullWidth>
        <DiscreteStates value={this.props.value} onClickDelete={this.props.onClickDelete}></DiscreteStates>
      </FormControl>
    );
  }

  errorText() {
    const { isValid } = this.state;

    return isValid ? (
      <Typography color="error">
        {this.props.t(['sensor:sensorDiscreteStates'], { defaultValue: 'At least one off and on state required' })}
      </Typography>
    ) : null;
  }
}
